var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { ControlWrapper, ControlButton, ControlPageCount, } from "./components";
let ProtableControls = class ProtableControls extends React.Component {
    constructor(props) {
        super(props);
        this.changePage = (forward) => {
            const { store, onPageChange } = this.props;
            const s = store.s;
            if (forward) {
                if (s.page + 1 <= store.totalPages) {
                    const page = s.page + 1;
                    if (onPageChange)
                        onPageChange(page);
                    store.setPage(page);
                }
            }
            else if (s.page - 1 >= 1) {
                const page = s.page - 1;
                if (onPageChange)
                    onPageChange(page);
                store.setPage(page);
            }
        };
        this.setFirstPage = () => {
            const { store, onPageChange } = this.props;
            const s = store.s;
            if (s.page !== 1) {
                if (onPageChange)
                    onPageChange(1);
                store.setPage(1);
            }
        };
        this.setLastPage = () => {
            const { store, onPageChange } = this.props;
            const s = store.s;
            if (s.page !== store.totalPages) {
                if (onPageChange)
                    onPageChange(store.totalPages);
                store.setPage(store.totalPages);
            }
        };
        this.state = {};
    }
    render() {
        const { store } = this.props;
        const s = store.s;
        return (React.createElement(ControlWrapper, null,
            React.createElement(ControlButton, { onClick: this.setFirstPage }, "First"),
            React.createElement(ControlButton, { onClick: () => this.changePage(false) }, "Previous"),
            React.createElement(ControlPageCount, null,
                s.page,
                " / ",
                store.totalPages),
            React.createElement(ControlButton, { onClick: () => this.changePage(true) }, "Next"),
            React.createElement(ControlButton, { onClick: this.setLastPage }, "Last")));
    }
};
ProtableControls = __decorate([
    observer
], ProtableControls);
export { ProtableControls };
//# sourceMappingURL=controls.js.map